import * as React from 'react';

export interface Props {
  background: string;
  children: any;
}

const HeroBanner = (props: Props) => (
  <div
    className={`col-xs-12 row center-xs middle-xs hero-banner ${props.background}-bg`}
  >
    <div className="box hero-banner-inner">{props.children}</div>
  </div>
);

export default HeroBanner;
